import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { PaymentMethodDto } from "@insite/client-framework/Types/ApiModels";
import {
    PopulateApiParameter,
    chain,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetOnePageCheckoutPaymentMethod";

type HandlerType = ApiHandlerDiscreteParameter<
    { paymentMethod?: PaymentMethodDto; isPlacingOrder: boolean },
    UpdateCartApiParameter
>;

export const PopulateApiParameterExtension: HandlerType = props => {
    const state = props.getState();
    const cart = getCurrentCartState(state).value;
    const { editedCartNotes } = state.pages.checkoutShipping;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to set a payment method on it.");
    }

    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;

    const defaultPaymentMethod = {
        paymentMethod: {
            // need to set name to empty string when removing payment method
            name: "",
        } as PaymentMethodDto,
    };

    const updatedCart: Cart = {
        ...cart,
        notes,
        ...(props.parameter.paymentMethod ? props.parameter : defaultPaymentMethod),
    };

    props.apiParameter = { cart: updatedCart };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);
